// Busca, filtro e ordem das listas de vendas da aba Pagamentos (feito na tela: as
// listas sao curtas, "A pagar" comeca em 01/11/2026 e "Fora" vem limitada a 500).

export const POR_PAGINA = 20;

export const FILTRO_VAZIO = { busca: '', canal: '', status: '', de: '', ate: '', ordem: 'recentes' };

export const ORDENS = [
    { value: 'recentes', label: 'Mais recentes' },
    { value: 'antigos', label: 'Mais antigas' },
    { value: 'maior', label: 'Maior comissão' },
    { value: 'menor', label: 'Menor comissão' },
];

const normalizar = (t) => String(t ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export const filtrarVendas = (vendas, f) => {
    const termo = normalizar(f.busca).replace(/^#/, '');
    const lista = vendas.filter((v) => {
        if (f.canal && v.canal !== f.canal) return false;
        if (f.status === 'concluida' && !v.concluida) return false;
        if (f.status === 'nao_concluida' && v.concluida) return false;
        const dia = String(v.data || '').slice(0, 10);
        if (f.de && dia < f.de) return false;
        if (f.ate && dia > f.ate) return false;
        if (!termo) return true;
        return [v.venda_id, v.id_origem, v.cliente].some((campo) => normalizar(campo).includes(termo));
    });

    const porData = (a, b) => String(a.data || '').localeCompare(String(b.data || '')) || a.venda_id - b.venda_id;
    const ordem = {
        recentes: (a, b) => porData(b, a),
        antigos: porData,
        maior: (a, b) => b.valor_centavos - a.valor_centavos || porData(b, a),
        menor: (a, b) => a.valor_centavos - b.valor_centavos || porData(b, a),
    }[f.ordem] || ((a, b) => porData(b, a));

    return [...lista].sort(ordem);
};

export const filtroAtivo = (f) => Boolean(f.busca || f.canal || f.status || f.de || f.ate);
